// ============================================================
// composerFocus (v8.363.4) - one registry so a hotkey pressed over the map
// can put the caret in the vox composer, wherever it is mounted, with an
// optional prefix already typed ('/' opens a command).
// ============================================================
type Focuser = (prefix?: string) => void;
let current: Focuser | null = null;

export function registerComposer(focus: Focuser | null): void {
  current = focus;
}

/** Focus the composer if one is mounted; true when it was. */
export function focusComposer(prefix = ''): boolean {
  if (!current) return false;
  current(prefix);
  return true;
}
